import PropTypes from "prop-types";
import React from "react";
import CandlestickChart from "./CandlestickChart";

// Health zone color coding for SpO2
const SPO2_COLORS = {
  normal: "#52c41a", // Green: 95-100%
  mild: "#faad14", // Yellow: 90-94%
  concerning: "#ff4d4f", // Red: <90%
};

const getSpO2Color = ({ low }) => {
  if (low >= 95) return SPO2_COLORS.normal;
  if (low >= 90) return SPO2_COLORS.mild;
  return SPO2_COLORS.concerning;
};

const SPO2_CONFIG = {
  height: 320,
  bodyWidth: 8,
  yAxisMin: 70,
  yAxisMax: 100,
  grid: { left: 20, right: 12, top: 16, bottom: 32 },
  unit: "%",
  getColor: getSpO2Color,
};

function SpO2Chart({ spo2Data }) {
  return <CandlestickChart data={spo2Data} config={SPO2_CONFIG} />;
}

SpO2Chart.propTypes = {
  spo2Data: PropTypes.shape({
    range: PropTypes.string,
    data_points: PropTypes.arrayOf(
      PropTypes.shape({
        timestamp: PropTypes.string,
        open: PropTypes.number,
        close: PropTypes.number,
        high: PropTypes.number,
        low: PropTypes.number,
        trend: PropTypes.string,
        type: PropTypes.string,
      })
    ),
  }),
};

SpO2Chart.defaultProps = {
  spo2Data: {
    range: "hour",
    data_points: [],
  },
};

export default SpO2Chart;
